import { render, staticRenderFns } from "./CardIssueModal.vue?vue&type=template&id=7551bd68&scoped=true"
import script from "./CardIssueModal.vue?vue&type=script&lang=js"
export * from "./CardIssueModal.vue?vue&type=script&lang=js"
import style0 from "./CardIssueModal.vue?vue&type=style&index=0&id=7551bd68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7551bd68",
  null
  
)

export default component.exports